import * as React from 'react';

import { AIGenerateBrandedIcon, AIGenerateIcon } from '@coursera/cds-icons';

import CoachButton from 'bundles/ai-coach-platform/components/building-blocks/CoachButton';

import _t from 'i18n!nls/ai-coach-platform';

import type { Props as CoachButtonProps } from './CoachButton';

export type Props = { children: string } & CoachButtonProps;

/**
 * Simple wrapper around CoachButton to provide some specific styles.
 */
export const CoachTriggerButton = (props: Props): React.ReactElement => {
  const { variant = 'secondary', children, ...rest } = props;

  return (
    <CoachButton
      variant={variant}
      size="small"
      aria-label={_t('#{label}, #{coachLabel} trigger', { label: children, coachLabel: 'Coach' })}
      icon={variant === 'primary' ? <AIGenerateIcon color="invert" /> : <AIGenerateBrandedIcon />}
      iconPosition="before"
      {...rest}
    >
      {children}
    </CoachButton>
  );
};

export default CoachTriggerButton;
